import "./ContactInfo.scss";
import { motion } from "framer-motion";
import { IoCall } from "react-icons/io5";
import { IoMailSharp } from "react-icons/io5";
import { FaLinkedinIn } from "react-icons/fa6";
import { Fragment, useEffect, useState } from "react";
import { baseUrl, contactPage } from "../../../utils/apiData";
import { Loader, MapComponent } from "../../../components";
import axios from "axios";
import { IoLocationSharp } from "react-icons/io5";

const ContactInfo = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState({});

  const contactApi = async () => {
    setLoader(true);
    try {
      const res = await axios.get(`${baseUrl}/${contactPage}`);
      if (res?.data?.success) {
        setData(res?.data?.data);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    contactApi();
  }, []);

  return (
    <Fragment>
      {loader ? (
        <Loader />
      ) : (
        <Fragment>
          <section className="contact_info pt-5 p_b">
            <div className="content_wrap p_t">
              <div className="info_grid pt-4">
                <div className="left">
                  <h2 className="gold">
                    {data?.get_in_touch_title &&
                      data?.get_in_touch_title
                        ?.split("")
                        .map((char, k) => (
                          <motion.span
                            initial={{ translateX: 24, opacity: 0 }}
                            whileInView={{ translateX: 0, opacity: 1 }}
                            transition={{
                              duration: 0.4,
                              ease: "easeInOut",
                              delay: 0.04 * k,
                            }}
                            key={k}
                          >
                            {char}
                          </motion.span>
                        ))
                        .concat("")}
                  </h2>
                  <p className="gold">{data?.get_in_touch_description}</p>
                </div>
                <div className="social_connect">
                  {data?.number && (
                    <a href={`tel:${data?.number}`} target="_blank">
                      <IoCall /> +99 99999 99999
                    </a>
                  )}
                  {data?.mail && (
                    <a href={`mailto:${data?.mail}`} target="_blank">
                      <IoMailSharp /> {data?.mail}
                    </a>
                  )}
                  {data?.linkedin_link && (
                    <a href={data?.linkedin_link} target="_blank">
                      <FaLinkedinIn /> Linkedin
                    </a>
                  )}
                </div>
              </div>
            </div>
          </section>
          <section className="address_sec p_b">
            <div className="content_wrap">
              <div className="title_line">
                <h2 className="gold">
                  {data?.office_title &&
                    data?.office_title
                      ?.split("")
                      .map((char, k) => (
                        <motion.span
                          initial={{ translateX: 24, opacity: 0 }}
                          whileInView={{ translateX: 0, opacity: 1 }}
                          transition={{
                            duration: 0.4,
                            ease: "easeInOut",
                            delay: 0.04 * k,
                          }}
                          key={k}
                        >
                          {char}
                        </motion.span>
                      ))
                      .concat("")}
                </h2>
                <p className="gold">{data?.office_description}</p>
              </div>
              <div className="address_grid">
                <div className="address_card">
                  <h4 className="gold">{data?.address_title}</h4>
                  <p className="gold">{data?.address_description}</p>

                  <h6 className="gold">
                    <IoLocationSharp /> {data?.office_location}
                  </h6>
                  <p className="gold">{data?.office_address}</p>
                </div>
                <div className="map_wrap">
                  {data?.office_lat && data?.office_long && (
                    <MapComponent
                      locationData={[
                        {
                          lat: +data?.office_lat,
                          lng: +data?.office_long,
                          location: data?.office_location,
                        },
                      ]}
                      card={false}
                    />
                  )}
                </div>
              </div>
            </div>
          </section>
        </Fragment>
      )}
    </Fragment>
  );
};

export default ContactInfo;
